import "../../App.css";
import { useAuth } from "../../contexts/AuthContext";
import { Container, Row, Col, Image, Nav, Button } from "react-bootstrap";

function AdminHeader({ onLoginClick }) {
  const { currentUser, logout } = useAuth();
  return (
    <Container className="header" fluid>
      <Row>
        <Col xs={12} md={5} className="d-flex flex-column justify-content-center py-2">
        <a href="/">
          <Image
            src="/white-logo.png"
            alt="CTGWeb 2.0 Logo"
            style={{ height: "45px", width: "auto", objectFit: 'contain' }}
          />
          </a>
          <h4 className="text-white mt-2 mb-0">Admin Dashboard</h4>
        </Col>
        <Col className="d-flex flex-column">
          <Row>
            <Col>
              <Nav
                variant="underline"
                className="justify-content-end"
                defaultActiveKey="/"
              >
                <Nav.Item>
                  {currentUser ? (
                    <Nav.Link className="navbar-link" href="/">
                      Return To Main
                    </Nav.Link>
                  ) : (
                    <Nav.Link className="navbar-link" href="/">
                      About
                    </Nav.Link>
                  )}
                </Nav.Item>
                {currentUser ? (
                  <Button className="log-button" onClick={logout}>
                    Logout
                  </Button>
                ) : (
                  <Button className="log-button" onClick={onLoginClick}>
                    Login
                  </Button>
                )}
              </Nav>
            </Col>
          </Row>
          <Row className="mt-auto">
            <Col>
            {currentUser ? (
              <p className="user-email text-end">Welcome, {currentUser?.user?.username}! ({currentUser?.user?.email})</p>
            ) : (
              <div></div>
            )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminHeader;
